module.exports = __webpack_public_path__ + "img/HealthHelp_Telehealth.27dae392.svg";